import axios from 'axios';
import { apiErrorHandler } from 'helpers/ApiHelper';

export const FETCH_DMA_OVERRIDES = 'FETCH_DMA_OVERRIDES';
export const FETCH_PLAYER_CONFIG = 'FETCH_PLAYER_CONFIG';

export function fetchDmaOverrides(route) {
  const request = axios.get(route).catch(e => apiErrorHandler({ error: e }));
  return {
    type: FETCH_DMA_OVERRIDES,
    payload: request,
  };
}

export function fetchPlayerConfig(playerConfigRoute) {
  const request = axios.get(playerConfigRoute).catch(e => apiErrorHandler({ error: e }));
  return {
    type: FETCH_PLAYER_CONFIG,
    payload: request,
  };
}
